import styled from "@emotion/styled";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/naming-convention
interface ButtonGroupProps {
  fullWidth?: boolean;
}

export const ButtonGroup = styled.div<ButtonGroupProps>`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-top: -8px;
  width: ${
    // FIXME: Fix this the next time the file is edited.
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
    (props: any) => (props.fullWidth ? "100%" : "")
  };

  & > * {
    margin-right: 8px;
    margin-top: 8px;
    flex: ${
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
      (props: any) => (props.fullWidth ? "1" : "")
    };

    &:last-child {
      margin-right: 0;
    }
  }

  & > button {
    min-width: 100px;
  }
`;

export const WideButtons = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-top: -8px;
  width: 90%;
  margin: 0 auto;

  button {
    flex: 1 0;
    flex-basis: 1fr;
    padding-top: 8px;
    padding-bottom: 8px;
    margin-right: 8px;
  }
`;
